"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var mock_1 = __importDefault(require("../../families/algorand/bridge/mock"));
var mock_2 = __importDefault(require("../../families/bitcoin/bridge/mock"));
var mock_3 = __importDefault(require("../../families/cosmos/bridge/mock"));
var mock_4 = __importDefault(require("../../families/ethereum/bridge/mock"));
var mock_5 = __importDefault(require("../../families/ripple/bridge/mock"));
var mock_6 = __importDefault(require("../../families/solana/bridge/mock"));
var mock_7 = __importDefault(require("../../families/stellar/bridge/mock"));
var mock_8 = __importDefault(require("../../families/tezos/bridge/mock"));
exports["default"] = {
    algorand: mock_1["default"],
    bitcoin: mock_2["default"],
    cosmos: mock_3["default"],
    ethereum: mock_4["default"],
    ripple: mock_5["default"],
    solana: mock_6["default"],
    stellar: mock_7["default"],
    tezos: mock_8["default"]
};
//# sourceMappingURL=mock.js.map